import { render, staticRenderFns } from "./base_info.vue?vue&type=template&id=51edb985&scoped=true"
import script from "./base_info.vue?vue&type=script&lang=js"
export * from "./base_info.vue?vue&type=script&lang=js"
import style0 from "./base_info.vue?vue&type=style&index=0&id=51edb985&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51edb985",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51edb985')) {
      api.createRecord('51edb985', component.options)
    } else {
      api.reload('51edb985', component.options)
    }
    module.hot.accept("./base_info.vue?vue&type=template&id=51edb985&scoped=true", function () {
      api.rerender('51edb985', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/activity/activity_program/form/components/base_info.vue"
export default component.exports